/** 后端统一响应结构 */
export interface ApiResult<T = unknown> {
  code: number
  message: string
  data: T
}

/** 分页请求参数 */
export interface PageParams {
  pageNum: number
  pageSize: number
}

/** 分页响应结构 */
export interface PageResult<T> {
  total: number
  list: T[]
}

/** 业务状态码 */
export const ApiCode = {
  SUCCESS: 0,
  UNAUTHORIZED: 30001,
  FORBIDDEN: 403,
} as const
